import React from "react";
import TwiceGroup from "../images/twicegroup.jpg";
import { Card, Icon } from "semantic-ui-react";

const Group = () => {
  return (
    <div className="group">
      <div className="spotify-div">
        <iframe
          src="https://open.spotify.com/embed/track/6HTwoo4dUOvePNqMsTarPA"
          width="300"
          height="380"
          frameborder="0"
          allowtransparency="true"
          allow="encrypted-media"
        ></iframe>
        <Card className="text" color="blue">
          <Card.Content className="header" header="Alcohol-Free"></Card.Content>
          <Card.Content>
            <a
              href="https://open.spotify.com/track/0BTaaKT4RMbs5M73tOHX5Y?si=96b6e9d6b1a049d8"
              target="_blank"
              style={{ color: "black", textDecoration: "none" }}
            >
              <Icon name="spotify" size="large" />
              Stream on Spotify
            </a>
          </Card.Content>
          <Card.Description>
            "Alcohol-Free" is the title track of TWICE's 10th mini album Taste
            of Love. The song and its music video were released on June 9, 2021
            with the full album set to be releasing 2 days later on June 11,
            2021.
          </Card.Description>
        </Card>
      </div>

      <div className="spotify-div">
        <Card className="text" color="blue">
          <Card.Content
            className="header"
            header="Taste Of Love Album"
          ></Card.Content>
          <Card.Content>
            <a
              href="https://open.spotify.com/track/0BTaaKT4RMbs5M73tOHX5Y?si=96b6e9d6b1a049d8"
              target="_blank"
              style={{ color: "black", textDecoration: "none" }}
            >
              <Icon name="spotify" size="large" />
              Out now on Spotify!
            </a>
          </Card.Content>
          <Card.Description>
            Taste of Love is the tenth extended play by South Korean girl group
            Twice. It was released on June 11, 2021, through JYP Entertainment
            and Republic Records
          </Card.Description>
        </Card>
        <iframe
          src="https://open.spotify.com/embed/album/00vb6sViDbJLmLLchfbRh4"
          width="300"
          height="380"
          frameborder="0"
          allowtransparency="true"
          allow="encrypted-media"
        ></iframe>
      </div>
    </div>
  );
};

export default Group;
